"use client";
import { Card, CardFooter } from "@/components/ui/card";

import CartFooter from "./cart-footer";
export default function EventTicketsCart({
  id,
  cart,
  tickets,
  validateCart,
  validateCartForm,
  step,
}: {
  id: any;
  cart: Record<string, number> | undefined;
  tickets: any[];
  validateCart: any;
  validateCartForm: () => boolean;
  step: string;
}) {
  const total =
    cart &&
    Object.entries(cart).reduce(
      (acc, [ticketId, quantity]) =>
        acc + (tickets.find((t) => t.id === ticketId)?.price || 0) * quantity,
      0
    );

  return (
    <>
      {cart && Object.values(cart).reduce((a, b) => a + b, 0) > 0 && (
        <div
          className={
            "w-full md:p-0 mt-20 md:mt-0 bottom-0 left-0 right-0 relative"
          }
        >
          <Card
            className="sticky top-20 rounded-md bg-background/50"
          >

            {/* <Sheet>
              <SheetTrigger className="w-full md:hidden">
                <CardHeader className="flex flex-row items-end justify-between w-full pt-5 pb-2 mb-10 lg:pt-6">
                  <CartHeader cart={cart} tickets={tickets} />
                  <ChevronUp className="absolute right-[calc(50%-10px)] top-0 animate-bounce opacity-25" />
                </CardHeader>
              </SheetTrigger>

              <SheetContent side="bottom">
                <SheetHeader>
                  <SheetTitle>
                    <CartHeader cart={cart} tickets={tickets} />
                  </SheetTitle>
                  <SheetDescription>
                    <CartContent tickets={tickets} cart={cart} />
                  </SheetDescription>
                  <CartFooter
                    total={total}
                    step={step}
                    validateCart={validateCart}
                    validateCartForm={validateCartForm}
                  />
                </SheetHeader>
              </SheetContent>
            </Sheet> */}


            <CardFooter className="flex flex-col items-start p-2">
              <CartFooter
                total={total}
                step={step}
                validateCart={validateCart}
                validateCartForm={validateCartForm}
              />
            </CardFooter>
          </Card>
        </div>
      )}
    </>
  );
}
